import axiosAuth from './axiosAuth'

export const getFaq = () => axiosAuth.get(`/faq`)

export const getFaqData = (key: string) => axiosAuth.get(`/faq/${key}`)

export const getFaqResponses = (key: string) =>
    axiosAuth.get(`/faq/${key}/response`)

export const getFaqExamples = (key: string) =>
    axiosAuth.get(`/faq/${key}/example`)

export const updateFaqKeyName = (keyName: string, newKeyName: string) =>
    axiosAuth.post(`/faq/${keyName}/set_name`, { intent_name: newKeyName })

export const deleteFaqKey = (keyName: string) =>
    axiosAuth.delete(`/faq/${keyName}`)

export const addFaqExample = (intentName: string, text: string) =>
    axiosAuth.post(`/faq/${intentName}/example`, { text: text })

export const deleteFaqExample = (intentName: string, exampleId: string) =>
    axiosAuth.delete(`/faq/${intentName}/example/${exampleId}`)

export const updateFaqExample = (
    intentName: string,
    exampleId: string,
    text: string
) => axiosAuth.put(`/faq/${intentName}/example/${exampleId}`, { text: text })

export const addFaqResponse = (intentName: string, obj: any) =>
    axiosAuth.post(`/faq/${intentName}/response`, obj)

export const deleteFaqResponse = (intentName: string, exampleId: string) =>
    axiosAuth.delete(`/faq/${intentName}/response/${exampleId}`)

export const updateFaqResponse = (
    intentName: string,
    responseId: string,
    obj: any
) => axiosAuth.put(`/faq/${intentName}/response/${responseId}`, obj)
